export default __webpack_public_path__ + "static/media/sh.419699ad.svg";